// Preview sessions use bearer authentication and never share panel cookies.
export const isWorkspacePreview = (hostname = window.location.hostname) =>
  ['preview-stage.gitdotme.com', 'preview.gitdotme.com'].includes(hostname);
